import React, { useState, useEffect } from "react";
import { Pie } from "react-chartjs-2";
import { PieChartWrapper, colors } from "./styles";
import { addDays } from "date-fns";
import CustomDatePicker from "./datepicker";
import { ChartTitle, ReportWrapper, Subtitle, DatepickerRow } from "./styles";
// import "chartjs-plugin-datalabels";
import { useQueryReport } from "../hooks/useQueryReport";
import { Card } from "react-bootstrap";
import { CardBody, CardHeader, CardTitle } from "reactstrap";
import { Link } from "react-router-dom";

const CountriesReport = (props) => {
  const INITIAL_STATE = {
    labels: [],
    values: [],
    colors: [],
  };
  const [reportData, setReportData] = useState(INITIAL_STATE);
  const [startDate, setStartDate] = useState(addDays(new Date(), -7));
  const [endDate, setEndDate] = useState(new Date());

  const { fetchData } = useQueryReport();

  const data = {
    labels: reportData.labels,
    datasets: [
      {
        data: reportData.values,
        backgroundColor: reportData.colors,
      },
    ],
  };
  console.log(reportData)
  const options = {
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          return data.labels[tooltipItem["index"]];
        },
      },
    },
    plugins: {
      datalabels: {
        // color: "black",
        font: {
          size: 10,
        },
        formatter: function (value, context) {

          const perc = parseInt((value / reportData.totalUsers) * 100);
          return perc + "%";
        },
      },
    },
  };

  useEffect(() => {
    const request = {
      viewID: props.viewID,
      startDate,
      endDate,
      metrics: "totalUsers",
      dimensions: ["country"],
      orderBy: {
        fieldName: "totalUsers",
        order: "DESCENDING",
      },
    };

    const displayResults = (response) => {
      const queryResult = response.reports[0].rows;
      let labels = [];
      let values = [];
      let bgColors = [];
      queryResult.forEach((row, idx) => {
        if (idx < 5) {
          labels.push(row.dimensionValues[0].value);
          values.push(row.metricValues[0].value[0]);
          bgColors.push(colors[idx + 1]);
        }
      });
      setReportData(prev => ({
        ...prev,
        labels,
        values,
        colors: bgColors,
        totalCoutries: queryResult.length,
        totalUsers: response.reports[0].rowCount,
      }));
    };

    setTimeout(
      () =>
        fetchData(request)
          .then((resp) => displayResults(resp))
          .catch((error) => console.error(error)),
      1000
    );
  }, [startDate, endDate, props.viewID, fetchData]);

  return (
    <>
      <Card className="card-chart shadow-lg border rounded">
        <CardHeader>
          <p className="card-category font-weight-bolder">Top 5 Countries by Users</p>
          <CardTitle tag="h4">
            <div className="">
              <div className="d-flex">
                <CustomDatePicker
                  placeholder={"Start date"}
                  date={startDate}
                  handleDateChange={(date) => setStartDate(date)}
                />
                <CustomDatePicker
                  placeholder={"End date"}
                  date={endDate}
                  handleDateChange={(date) => setEndDate(date)}
                />
              </div>
            </div>
            <i className="tim-icons icon-single-02" /> {`Total countries - ${reportData.totalCoutries}`}
            {/* {formatter.format(total_users)} */}

          </CardTitle>
        </CardHeader>
        <CardBody>

          {reportData && (
            <Pie data={data} options={options} height={260} />
          )}

        </CardBody>
      </Card>
    </>

  );
};

export default CountriesReport;
